import Vue from 'vue'
import Toast from './Toast.vue'

const ToastConstructor = Vue.extend(Toast)

let toastInstance = null
function toast ({ type, message, showTime, title = '' }) {
  if (toastInstance === null) {
    toastInstance = new ToastConstructor()
  }
  const prom = new Promise(resolve => {
    toastInstance.type = type
    toastInstance.message = message
    toastInstance.resolve = resolve
    toastInstance.showTime = showTime
    toastInstance.title = title
    if (!toastInstance.isMounted) {
      const dom = document.createElement('div')
      document.querySelector('body').appendChild(dom)
      toastInstance.$mount(dom)
    }
    toastInstance.show()
  })
  toastInstance.prom = prom
  return toastInstance
}

function successToast ({ message = '已完成', showTime = 3000 } = {}) {
  return toast({ type: 'success', message, showTime })
}

function loadingToast ({ message = '加载中', showTime = null } = {}) {
  return toast({ type: 'loading', message, showTime })
}

function networkErrorToast ({
  message = '当前无网络，请检查网络后再试',
  showTime = 3000
} = {}) {
  return toast({ type: 'network', message, showTime })
}

export { toast, successToast, loadingToast, networkErrorToast }
